<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Composto" class="mb-2">
      <b-row class="mb-5">
        <b-col cols="12" sm="7" class="mb-2">
          <Search
            @changeSearchValue="searchValue = $event"
            searchPlaceholder="Buscar por Número do Composto"
          />
        </b-col>
        <b-col>
          <b-row class="justify-content-end mr-1">
            <b-col cols="auto">
              <b-button
                variant="outline-secondary"
                v-on:click="goToNewCompound"
                class="mr-3"
              >
                <b-icon icon="plus-circle-fill"></b-icon> Adicionar
              </b-button>
              <b-button variant="outline-secondary" @click="exportPDF()">
                <b-icon icon="download"></b-icon> Exportar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="justify-content-end">
        <b-col cols="auto">
          <Filters @changeDate="year = $event.date.year" />
        </b-col>
      </b-row>

      <div v-if="!isCompoundsEmpty">
        <CompoundCard
          v-for="composto in filteredCompounds"
          :key="composto.compound_number"
          :compound="composto"
          @exclusao="handleDiscard"
        ></CompoundCard>
      </div>
      <p v-else-if="isSearchEmpty" class="message-no-clients-filtered mt-5">
        Não há compostos cadastrados.
      </p>
      <p v-else class="message-no-clients-filtered mt-5">
        Não há composto cadastrado de número '{{ searchValue }}'.
      </p>

      <ModalExcluirComposto
        @compostoTrocado="handleTroca($event)"
        :isDiscarded="isDiscardedCompound"
      />
      <ModalConfirmationDelete @exclusaoConfirmada="handleDeleteConfirmation" />
    </Dashboard>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import JsPDF from 'jspdf';
import 'jspdf-autotable';

import Filters from '../components/Filters.vue';
import CompoundCard from '../components/compound/CompoundCard.vue';
import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import Search from '../components/Search.vue';
import Sidebar from '../components/Sidebar.vue';
import ModalExcluirComposto from '../components/compound/ModalExcluirComposto.vue';
import ModalConfirmationDelete from '../components/ModalConfirmationDelete.vue';
import MixinConvertDate from '../utils/MixinConvertDate';
import MixinExportPDF from '../utils/MixinExportPDF';
import {
  Compounds,
  DescartaCompound,
  RemoveCompound,
} from '../services/Compound';
import showError from '../utils/showError';

export default {
  components: {
    HeaderVue,
    Sidebar,
    Dashboard,
    Search,
    CompoundCard,
    ModalExcluirComposto,
    ModalConfirmationDelete,
    Filters,
  },

  data() {
    return {
      year: new Date().getFullYear(),
      compoundChangedNumber: null,
      isDiscardedCompound: null,
      compounds: [],
      searchValue: '',
    };
  },

  created() {
    Compounds()
      .then((res) => {
        this.compounds = res.data;

        this.compounds.forEach((compound) => {
          if (!compound.product) {
            compound.product = [
              {
                type: 'Não informado',
              },
            ];
          }
        });
      })
      .catch(showError);
  },

  mixins: [MixinConvertDate, MixinExportPDF],

  methods: {
    goToNewCompound() {
      this.$router.push('/novo-composto');
    },

    handleDiscard(compoundId, isDiscarded) {
      this.$bvModal.show('modal-excluir-composto');
      this.compoundChangedNumber = compoundId;
      this.isDiscardedCompound = isDiscarded;
    },

    handleTroca(descartado) {
      const compoundToBeChanged = this.compounds.find(
        (compound) => compound.id === this.compoundChangedNumber
      );
      const form = {
        is_discarded: false,
      };

      if (descartado === 'descartar') {
        form.is_discarded = true;
      } else {
        form.is_discarded = false;
      }

      DescartaCompound(compoundToBeChanged.id, form)
        .then(() => {
          this.$bvModal.hide('modal-excluir-composto');
          this.$toasted.global.defaultSuccess();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(showError);
    },

    handleDeleteConfirmation() {
      this.$bvModal.hide('modal-excluir-composto');
      this.$bvModal.hide('modal-confirmation-delete');
      try {
        RemoveCompound(this.compoundChangedNumber);
        this.$toasted.global.defaultSuccess();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch {
        showError('Erro ao excluir composto do sistema');
      }
    },

    addTablePDF(doc) {
      const startY = 90;
      const head = [
        [
          'N° do Composto',
          'Tipo de Cogumelo',
          'Data de Chegada',
          'Qtd. Produzida',
        ],
      ];

      const body = [];
      this.compounds.forEach((compound) => {
        body.push([
          compound.compound_number,
          compound.product.type,
          this.convertDate(compound.arrived_date),
          compound.quantity_produced,
        ]);
      });

      doc.autoTable({
        head,
        body,
        startY,
        theme: 'grid',
        headStyles: {
          fontSize: 12,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.26,
          lineColor: '#B6B6B6',
          halign: 'center',
          valign: 'middle',
        },
        columnStyles: {
          0: {
            halign: 'center',
            cellWidth: 50,
            lineWidth: 0.26,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
          1: {
            halign: 'center',
            cellWidth: 40,
            lineWidth: 0.26,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
          2: {
            halign: 'center',
            cellWidth: 40,
            lineWidth: 0.26,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
          3: {
            halign: 'center',
            cellWidth: 50,
            lineWidth: 0.26,
            lineColor: '#B6B6B6',
            textColor: [0, 0, 0],
            valign: 'middle',
          },
        },
        cellStyles: {
          class: 'custom-font',
        },
      });

      return doc;
    },

    async exportPDF() {
      const doc = new JsPDF();

      /* eslint-disable global-require */

      // Adiciona a logomarca
      const imageUrl = require('../assets/logo.jpg');
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', 14, 3, 50, 25);

      this.addHeaderPDF(doc);
      this.addTitlePDF(doc, 'Compostos', 'Dados Gerais');
      this.addTablePDF(doc);

      doc.save('Compostos.pdf');
      /* eslint-enable global-require */
    },
  },

  computed: {
    filteredCompounds() {
      // aqui testando data ainda como uma string e nao uma Date, por isso a gambiarra de pegar o ano com .slice()
      const filteredByYear = this.compounds.filter(
        (compound) => compound.arrived_date.slice(0, 4) === this.year.toString()
      );

      if (this.searchValue !== '') {
        return filteredByYear.filter((compound) =>
          compound.compound_number.toString().includes(this.searchValue)
        );
      }

      return filteredByYear;
    },
    isCompoundsEmpty() {
      return this.filteredCompounds.length === 0;
    },
    isSearchEmpty() {
      return this.searchValue === '';
    },
  },
};
</script>

<style scoped>
#year-selector {
  flex-wrap: nowrap;
  width: 160px;
  height: 35px;
  font-size: 1.5rem;
  background: #d4d4d4;
  border-radius: 15px;
}

.btn-selector {
  min-width: 20%;
  height: 100%;
  background-color: #d4d4d4;
  border: none;
  font-weight: bolder;
}

.btn-selector:focus {
  border: none;
  outline: none;
}
</style>
